import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { prepare_description } from 'console/tabs/legacy/opentherm-dialog/opentherm-errcodes-legacy';
import { UniversalDialog } from 'console/dialogs/universal';
import { Typography } from '@mui/material';
export const OTErrorDialog = memo(function OTErrorDialog(props) {
    const { open, spec, oem_code, onClose } = props;
    const prepared = prepare_description(spec);
    if (prepared == null) {
        return null;
    }
    const { more_title, more_html } = prepared;
    if (more_html == null) {
        return null;
    }
    if (more_title)
        return (_jsxs(UniversalDialog, { open: open, title: oem_code ?? 'Расшифровка ошибки', onClose: onClose, children: [_jsx(Typography, { variant: "subtitle1", children: _jsx("b", { children: more_title }) }), _jsx("div", { className: "ui-boiler-fail-pane-dialog", dangerouslySetInnerHTML: { __html: more_html } })] }));
    return null;
});
